require('../../subscription/frontend/email_suggest.coffee');

require('../../subscription/frontend/placeholder_input.coffee');

require('./subs_success_banner.coffee');

require('../../groupon/frontend/groupon.coffee');

require('../../groupon/frontend/validate.coffee');

Groupon.EmailZip = (function() {
  var email, error, postal_code, submit_button, success, updated_email_bg_position, updated_zip_bg_position;

  success = 'js-success';

  error = 'js-error';

  postal_code = $('#postal_code_id');

  email = $('#email_id');

  submit_button = $('#submit_button');

  updated_email_bg_position = false;

  updated_zip_bg_position = false;

  email.keydown(function(e) {
    if (e.keyCode === 13 && !Groupon.EmailZip.validateAttributes(email, postal_code)) {
      return e.preventDefault();
    }
  });

  email.keyup(function(e) {
    return Groupon.EmailZip.emailChanged(e);
  });

  email.on('change input', function(e) {
    return Groupon.EmailZip.emailChanged(e);
  });

  postal_code.keyup(function(e) {
    return Groupon.EmailZip.postalCodeChanged(e);
  });

  postal_code.keydown(function(e) {
    if (e.keyCode === 13 && !Groupon.EmailZip.validateAttributes(email, postal_code)) {
      return e.preventDefault();
    }
  });

  postal_code.change(function(e) {
    return Groupon.EmailZip.postalCodeChanged(e);
  });

  submit_button.click(function(e) {
    return Groupon.EmailZip.stepSubmit(e);
  });

  $('#hide_banner').click(function(e) {
    return Groupon.EmailZip.hideBanner(e);
  });

  $('#nothx').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $('#closeid').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $('#continue').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $(document).ready(function() {
    var $bg, resizeSubsBg, theWindow;
    resizeSubsBg = function() {
      var newHeight, newWidth;
      if ((theWindow.width() / theWindow.height()) < subs_bg_aspectRatio) {
        newWidth = theWindow.height() * subs_bg_aspectRatio;
        return $bg.css({
          top: "0px",
          height: theWindow.height() + "px",
          width: newWidth + "px",
          left: ((theWindow.width() - newWidth) / 2) + "px"
        });
      } else {
        newHeight = theWindow.width() / subs_bg_aspectRatio;
        return $bg.css({
          left: "0px",
          width: theWindow.width() + "px",
          height: newHeight + "px",
          top: ((theWindow.height() - newHeight) / 2) + "px"
        });
      }
    };
    theWindow = $(window);
    $bg = $("#subscription-bg");
    if ($bg.length > 0) {
      return theWindow.resize(resizeSubsBg).trigger("resize");
    }
  });

  function EmailZip() {
    email.emailSuggestions();
    email.placeholderInput();
    postal_code.placeholderInput();
    setTimeout((function() {
      return email.setCursorPosition(0);
    }), 100);
  }

  EmailZip.inputSuccessHandler = function(input) {
    input.removeClass(error);
    input.addClass(success);
    return submit_button.attr('disabled', false);
  };

  EmailZip.errorHandler = function() {
    this.emailHandler();
    this.postalCodeHandler();
    return submit_button.attr('disabled', true);
  };

  EmailZip.inputErrorHandler = function(input) {
    input.removeClass(success);
    input.addClass(error);
    return submit_button.attr('disabled', true);
  };

  EmailZip.emailHandler = function(ev) {
    if (this.validateEmail(email.val())) {
      this.inputSuccessHandler(email);
      if ((ev != null ? ev.keyCode : void 0) === 13) {
        return submit_button.trigger('click');
      }
    } else if ((email.attr('placeholder') != null) && email.val() === email.attr('placeholder')) {
      email.removeClass('js-success');
      return email.removeClass('js-error');
    } else {
      return this.inputErrorHandler(email);
    }
  };

  EmailZip.postalCodeHandler = function(ev) {
    if (this.validateZipCode(postal_code.val())) {
      this.inputSuccessHandler(postal_code);
      if ((ev != null ? ev.keyCode : void 0) === 13) {
        return submit_button.trigger('click');
      }
    } else if ((postal_code.attr('placeholder') != null) && postal_code.val() === postal_code.attr('placeholder')) {
      postal_code.removeClass('js-success');
      return postal_code.removeClass('js-error');
    } else {
      return this.inputErrorHandler(postal_code);
    }
  };

  EmailZip.emailChanged = function(ev) {
    if (this.completed) {
      return;
    }
    if (!updated_email_bg_position) {
      if (!$('body').hasClass('rtl') && !$('#sub_dlg').hasClass('centered')) {
        email.css({
          'backgroundPosition': (email.width() + 12) + 'px'
        });
      }
      updated_email_bg_position = true;
    }
    this.emailHandler(ev);
    if ($(ev.currentTarget).val() === '') {
      return email.removeClass(error);
    }
  };

  EmailZip.postalCodeChanged = function(ev) {
    if (!updated_zip_bg_position) {
      if (!$('body').hasClass('rtl')) {
        postal_code.css({
          'backgroundPosition': (postal_code.width() + 12) + 'px'
        });
      }
      updated_zip_bg_position = true;
    }
    if (this.completed) {
      return;
    }
    this.postalCodeHandler(ev);
    if ($(ev.currentTarget).val() === '') {
      return postal_code.removeClass(error);
    }
  };

  EmailZip.stepSubmit = function(ev) {
    ev.preventDefault();
    if (this.validateAttributes(email, postal_code)) {
      this.completed = true;
      $('#sub_dlg').trigger('dismiss');
      $('#sub_non_modal').trigger('dismiss');
      $('#js-zip-modal-step').trigger('dismiss');
      return $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ev.currentTarget.form.action,
        data: $(ev.currentTarget.form).serialize(),
        success: function(data) {
          var bannerText, i18nObj, ref, ref1, ref2, successStringKey;
          i18nObj = I18n;
          successStringKey = "js.modules.subscription.subscription_success";
          if (typeof subsI18n !== "undefined" && subsI18n !== null) {
            i18nObj = subsI18n;
          }
          if ((data.incentiveStatus != null) && data.incentiveStatus === 'success') {
            successStringKey = "js.modules.subscription.subscription_success_subsave";
          }
          bannerText = i18nObj.translate(successStringKey, {
            division: data.divisionName,
            email: email.val()
          });
          window.create_subscription_result_banner('success', bannerText, 'block');
          if (window._subscriptionSuccessCallback != null) {
            window._subscriptionSuccessCallback(data.divisionId, postal_code.val());
          }
          OptimizeSuite.TrackingHub.add('goalEmailZip', {
            goalType: 'subscription',
            goalId: data.subscriptionId
          });
          OptimizeSuite.InteractionGoals.subscription({
            scid: Cookie.get('scid'),
            division: typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.division : void 0 : void 0,
            country: typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.country : void 0 : void 0,
            channel: typeof Optimize !== "undefined" && Optimize !== null ? (ref2 = Optimize.suiteData) != null ? ref2.channel : void 0 : void 0,
            clickId: OptimizeSuite.getLastEventId(),
            consumerId: data.consumerId
          });
          $('#sub_dlg').trigger('success');
          $('#sub_non_modal').trigger('success');
          return $('#js-zip-modal-step').trigger('success');
        },
        error: function(xhr) {
          var bannerText, i18nObj;
          i18nObj = I18n;
          if (typeof subsI18n !== "undefined" && subsI18n !== null) {
            i18nObj = subsI18n;
          }
          bannerText = i18nObj.translate("js.modules.subscription.subscription_failure", {
            link_open: "<a href='#' onclick='retrySubscriptionAfterFailure()'>",
            link_close: "</a>"
          });
          window.create_subscription_result_banner('error', bannerText, 'block');
          OptimizeSuite.TrackingHub.add('goalEmailZip', {
            goalType: 'subscription',
            fail: xhr.responseText
          });
          $('#sub_dlg').trigger('fail');
          return $('#sub_non_modal').trigger('fail');
        }
      });
    } else {
      return this.errorHandler();
    }
  };

  EmailZip.hideBanner = function(ev) {
    Cookie.set('close_subscribe_drawer', true);
    return $('#sub_non_modal').trigger('dismiss');
  };

  EmailZip.triggerClose = function() {
    $('#sub_dlg').trigger('close');
    return $('#js-zip-modal-step').trigger('close');
  };

  EmailZip.validateAttributes = function(email, zip) {
    return (zip.size() === 0 || this.validateZipCode(zip.val())) && this.validateEmail(email.val());
  };

  EmailZip.validateEmail = function(email) {
    if ((email == null) || email === '') {
      return false;
    }
    return Groupon.Validate.email(email);
  };

  EmailZip.validateZipCode = function(zip) {
    if ((zip == null) || zip === '') {
      return false;
    }
    return Groupon.Validate.zip(zip);
  };

  return EmailZip;

})();

new Groupon.EmailZip();

//# sourceMappingURL=data:application/json;base64,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
